require('../../subscription/frontend/email_suggest.coffee');

require('../../subscription/frontend/placeholder_input.coffee');

require('./subs_success_banner.coffee');

require('../../groupon/frontend/groupon.coffee');

require('../../groupon/frontend/validate.coffee');

Groupon.EmailZip = (function() {
  var email, error, postal_code, submit_button, success, updated_email_bg_position, updated_zip_bg_position;

  success = 'js-success';

  error = 'js-error';

  postal_code = $('#postal_code_id');

  email = $('#email_id');

  submit_button = $('#submit_button');

  updated_email_bg_position = false;

  updated_zip_bg_position = false;

  email.keydown(function(e) {
    if (e.keyCode === 13 && !Groupon.EmailZip.validateAttributes(email, postal_code)) {
      return e.preventDefault();
    }
  });

  email.keyup(function(e) {
    return Groupon.EmailZip.emailChanged(e);
  });

  email.on('change input', function(e) {
    return Groupon.EmailZip.emailChanged(e);
  });

  postal_code.keyup(function(e) {
    return Groupon.EmailZip.postalCodeChanged(e);
  });

  postal_code.keydown(function(e) {
    if (e.keyCode === 13 && !Groupon.EmailZip.validateAttributes(email, postal_code)) {
      return e.preventDefault();
    }
  });

  postal_code.change(function(e) {
    return Groupon.EmailZip.postalCodeChanged(e);
  });

  submit_button.click(function(e) {
    return Groupon.EmailZip.stepSubmit(e);
  });

  $('#hide_banner').click(function(e) {
    return Groupon.EmailZip.hideBanner(e);
  });

  $('#nothx').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $('#closeid').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $('#continue').click(function(e) {
    Groupon.EmailZip.triggerClose();
    e.preventDefault();
    return true;
  });

  $(document).ready(function() {
    var $bg, resizeSubsBg, theWindow;
    resizeSubsBg = function() {
      var newHeight, newWidth;
      if ((theWindow.width() / theWindow.height()) < subs_bg_aspectRatio) {
        newWidth = theWindow.height() * subs_bg_aspectRatio;
        return $bg.css({
          top: "0px",
          height: theWindow.height() + "px",
          width: newWidth + "px",
          left: ((theWindow.width() - newWidth) / 2) + "px"
        });
      } else {
        newHeight = theWindow.width() / subs_bg_aspectRatio;
        return $bg.css({
          left: "0px",
          width: theWindow.width() + "px",
          height: newHeight + "px",
          top: ((theWindow.height() - newHeight) / 2) + "px"
        });
      }
    };
    theWindow = $(window);
    $bg = $("#subscription-bg");
    if ($bg.length > 0) {
      return theWindow.resize(resizeSubsBg).trigger("resize");
    }
  });

  function EmailZip() {
    email.emailSuggestions();
    email.placeholderInput();
    postal_code.placeholderInput();
    setTimeout((function() {
      return email.setCursorPosition(0);
    }), 100);
  }

  EmailZip.inputSuccessHandler = function(input) {
    input.removeClass(error);
    input.addClass(success);
    return submit_button.attr('disabled', false);
  };

  EmailZip.errorHandler = function() {
    this.emailHandler();
    this.postalCodeHandler();
    return submit_button.attr('disabled', true);
  };

  EmailZip.inputErrorHandler = function(input) {
    input.removeClass(success);
    input.addClass(error);
    return submit_button.attr('disabled', true);
  };

  EmailZip.emailHandler = function(ev) {
    if (this.validateEmail(email.val())) {
      this.inputSuccessHandler(email);
      if ((ev != null ? ev.keyCode : void 0) === 13) {
        return submit_button.trigger('click');
      }
    } else if ((email.attr('placeholder') != null) && email.val() === email.attr('placeholder')) {
      email.removeClass('js-success');
      return email.removeClass('js-error');
    } else {
      return this.inputErrorHandler(email);
    }
  };

  EmailZip.postalCodeHandler = function(ev) {
    if (this.validateZipCode(postal_code.val())) {
      this.inputSuccessHandler(postal_code);
      if ((ev != null ? ev.keyCode : void 0) === 13) {
        return submit_button.trigger('click');
      }
    } else if ((postal_code.attr('placeholder') != null) && postal_code.val() === postal_code.attr('placeholder')) {
      postal_code.removeClass('js-success');
      return postal_code.removeClass('js-error');
    } else {
      return this.inputErrorHandler(postal_code);
    }
  };

  EmailZip.emailChanged = function(ev) {
    if (this.completed) {
      return;
    }
    if (!updated_email_bg_position) {
      if (!$('body').hasClass('rtl') && !$('#sub_dlg').hasClass('centered')) {
        email.css({
          'backgroundPosition': (email.width() + 12) + 'px'
        });
      }
      updated_email_bg_position = true;
    }
    this.emailHandler(ev);
    if ($(ev.currentTarget).val() === '') {
      return email.removeClass(error);
    }
  };

  EmailZip.postalCodeChanged = function(ev) {
    if (!updated_zip_bg_position) {
      if (!$('body').hasClass('rtl')) {
        postal_code.css({
          'backgroundPosition': (postal_code.width() + 12) + 'px'
        });
      }
      updated_zip_bg_position = true;
    }
    if (this.completed) {
      return;
    }
    this.postalCodeHandler(ev);
    if ($(ev.currentTarget).val() === '') {
      return postal_code.removeClass(error);
    }
  };

  EmailZip.stepSubmit = function(ev) {
    ev.preventDefault();
    if (this.validateAttributes(email, postal_code)) {
      this.completed = true;
      $('#sub_dlg').trigger('dismiss');
      $('#sub_non_modal').trigger('dismiss');
      $('#js-zip-modal-step').trigger('dismiss');
      return $.ajax({
        type: 'POST',
        dataType: 'json',
        url: ev.currentTarget.form.action,
        data: $(ev.currentTarget.form).serialize(),
        success: function(data) {
          var bannerText, i18nObj, ref, ref1, ref2, successStringKey;
          i18nObj = I18n;
          successStringKey = "js.modules.subscription.subscription_success";
          if (typeof subsI18n !== "undefined" && subsI18n !== null) {
            i18nObj = subsI18n;
          }
          if ((data.incentiveStatus != null) && data.incentiveStatus === 'success') {
            successStringKey = "js.modules.subscription.subscription_success_subsave";
          }
          bannerText = i18nObj.translate(successStringKey, {
            division: data.divisionName,
            email: email.val()
          });
          window.create_subscription_result_banner('success', bannerText, 'block');
          if (window._subscriptionSuccessCallback != null) {
            window._subscriptionSuccessCallback(data.divisionId, postal_code.val());
          }
          OptimizeSuite.TrackingHub.add('goalEmailZip', {
            goalType: 'subscription',
            goalId: data.subscriptionId
          });
          OptimizeSuite.InteractionGoals.subscription({
            scid: Cookie.get('scid'),
            division: typeof Optimize !== "undefined" && Optimize !== null ? (ref = Optimize.suiteData) != null ? ref.division : void 0 : void 0,
            country: typeof Optimize !== "undefined" && Optimize !== null ? (ref1 = Optimize.suiteData) != null ? ref1.country : void 0 : void 0,
            channel: typeof Optimize !== "undefined" && Optimize !== null ? (ref2 = Optimize.suiteData) != null ? ref2.channel : void 0 : void 0,
            clickId: OptimizeSuite.getLastEventId(),
            consumerId: data.consumerId
          });
          $('#sub_dlg').trigger('success');
          $('#sub_non_modal').trigger('success');
          return $('#js-zip-modal-step').trigger('success');
        },
        error: function(xhr) {
          var bannerText, i18nObj;
          i18nObj = I18n;
          if (typeof subsI18n !== "undefined" && subsI18n !== null) {
            i18nObj = subsI18n;
          }
          bannerText = i18nObj.translate("js.modules.subscription.subscription_failure", {
            link_open: "<a href='#' onclick='retrySubscriptionAfterFailure()'>",
            link_close: "</a>"
          });
          window.create_subscription_result_banner('error', bannerText, 'block');
          OptimizeSuite.TrackingHub.add('goalEmailZip', {
            goalType: 'subscription',
            fail: xhr.responseText
          });
          $('#sub_dlg').trigger('fail');
          return $('#sub_non_modal').trigger('fail');
        }
      });
    } else {
      return this.errorHandler();
    }
  };

  EmailZip.hideBanner = function(ev) {
    Cookie.set('close_subscribe_drawer', true);
    return $('#sub_non_modal').trigger('dismiss');
  };

  EmailZip.triggerClose = function() {
    $('#sub_dlg').trigger('close');
    return $('#js-zip-modal-step').trigger('close');
  };

  EmailZip.validateAttributes = function(email, zip) {
    return (zip.size() === 0 || this.validateZipCode(zip.val())) && this.validateEmail(email.val());
  };

  EmailZip.validateEmail = function(email) {
    if ((email == null) || email === '') {
      return false;
    }
    return Groupon.Validate.email(email);
  };

  EmailZip.validateZipCode = function(zip) {
    if ((zip == null) || zip === '') {
      return false;
    }
    return Groupon.Validate.zip(zip);
  };

  return EmailZip;

})();

new Groupon.EmailZip();

//# sourceMappingURL=data:application/json;base64,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
